var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormulateButton',{attrs:{"title":_vm.context.label,"has-errors":this.context.attributes.hasErrors,"form-handler":this.context.attributes.formHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }